// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/solo-flight-considerations.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/solo-flight-considerations/solo-flight-considerations.js';

mount([g0]);
